<div class="flex" style="gap:10px;align-items: flex-end;">
  
  <app-select-input [(ngModel)]="selDateRange" (changed)="dateRangeChanged()" [options]="dateRangeOpts"></app-select-input>
  
  <ng-container *ngIf="selDateRange == DateRange.Custom">
    <app-datetime-input label="From" type="date" [(ngModel)]="startDateString" name="from" 
      (blurredAndValid)="applyFilter(true)"></app-datetime-input>
    <app-datetime-input label="To" type="date" [(ngModel)]="endDateString" name="to" 
      (blurredAndValid)="applyFilter(true)"></app-datetime-input>
    <ion-button (click)="applyFilter()" *ngIf="applyOnEdit == false">Apply</ion-button>
  </ng-container>
</div>